/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online Unicode character inspector. Break any text into characters and see each one's code point, U+ value, and UTF-8 bytes. Works in your browser.`)
};

const es_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector de caracteres Unicode gratuito en línea. Divide cualquier texto en caracteres y ve el punto de código, valor U+, y bytes UTF-8 de cada uno. Funciona en tu navegador.`)
};

const de_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Unicode-Zeichen-Inspektor. Zerlegen Sie beliebigen Text in Zeichen und sehen Sie den Codepunkt, den U+-Wert und die UTF-8-Bytes jedes einzelnen. Funktioniert direkt in Ihrem Browser.`)
};

const nl_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online Unicode-karakterinspecteur. Breek tekst op in karakters en zie het codepunt, U+-waarde en UTF-8-bytes van elk karakter. Werkt in je browser.`)
};

const fr_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur Unicode en ligne gratuit. Décomposez n'importe quel texte en caractères et consultez le point de code, la valeur U+ et les octets UTF-8 de chacun. Fonctionne dans votre navigateur.`)
};

const it_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore gratuito online di caratteri Unicode. Dividi qualsiasi testo in caratteri e visualizza il punto di codice, il valore U+, e i byte UTF-8 di ciascuno. Funziona nel tuo browser.`)
};

const pt_br2_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor Unicode de caracteres on-line gratuito. Divida qualquer texto em caracteres e veja o ponto de código, valor U+ e bytes UTF-8 de cada um. Funciona no seu navegador.`)
};

const pt_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de caracteres Unicode gratuito online. Divida qualquer texto em caracteres e veja o ponto de código, o valor U+ e os bytes UTF-8 de cada um. Funciona no seu navegador.`)
};

const ja_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「無料のオンライン Unicode 文字インスペクタ。任意のテキストを文字に分割し、各文字のコードポイント、U+ 値、UTF-8 バイトを確認できます。ブラウザで動作します。」`)
};

const zh_ci_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 Unicode 字符检查器。将任意文本拆分为字符，查看每个字符的码点、U+ 值和 UTF-8 字节。可在您的浏览器中使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_meta_description", locale)
	if (locale === "en") return en_ci_meta_description(inputs)
	if (locale === "es") return es_ci_meta_description(inputs)
	if (locale === "de") return de_ci_meta_description(inputs)
	if (locale === "nl") return nl_ci_meta_description(inputs)
	if (locale === "fr") return fr_ci_meta_description(inputs)
	if (locale === "it") return it_ci_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ci_meta_description(inputs)
	if (locale === "pt") return pt_ci_meta_description(inputs)
	if (locale === "ja") return ja_ci_meta_description(inputs)
	return zh_ci_meta_description(inputs)
};